import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { IAppState } from '../../../../../state/reducers';
import { toggleNotFound, isGameAvailable } from '../../../../../state/exchange/searchResults';
import { FaIcon } from '../../../../Shared';
import { IProps, IStateProps, IDispatchProps } from './interfaces';
import { NotFoundLabel } from './styles';
import NotFoundDialog from './NotFoundDialog/component';

class ExchangeResultsInfo extends React.Component<IProps> {
  renderGamesQuantityMessage = () => {
    const { games, isLoading } = this.props;
    let gamesLength;

    if (games === null) {
      gamesLength = 0;
    } else {
      gamesLength = games.filter(isGameAvailable).length;
    }

    return (
      <span>
        {isLoading && (
          <>
            <FaIcon
              icon={faSpinner}
              spin
              $small
            />&nbsp;
          </>
        )}{`${gamesLength} Game${gamesLength === 1 ? '' : 's'} Found.`}
      </span>
    );
  };

  renderNotFoundMessage = () => {
    const { teamsWithoutGames, onSeeMore } = this.props;
    if (teamsWithoutGames === null || !teamsWithoutGames.length) {
      return null;
    }
    const message = ' No results found for';
    if (teamsWithoutGames.length > 3) {
      return (
        <>
          <NotFoundDialog
            teamsWithoutGames={teamsWithoutGames}
          />
          {`${message} ${teamsWithoutGames.sort().slice(0, 3).join(', ')}... `}
          <NotFoundLabel
            onClick={onSeeMore}
          >
            see more
          </NotFoundLabel>
        </>
      );
    }
    return `${message} ${teamsWithoutGames.sort().join(', ')}`;
  };

  render() {
    return (
      <div>
        {this.renderGamesQuantityMessage()}
        {this.renderNotFoundMessage()}
      </div>
    );
  }
}

const mapStateToProps = (state: IAppState): IStateProps => ({
  isLoading: state.exchange.searchResults.isLoading,
  games: state.exchange.searchResults.games,
  teamsWithoutGames: state.exchange.searchResults.teamsWithoutGames,
});

const mapDispatchToProps: IDispatchProps = {
  onSeeMore: toggleNotFound,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ExchangeResultsInfo);
